<template>
  <div class="p-2 border-gray rounded-lg">
    <div class="flex items-center text-black font-normal text-lg">
      <span class="ml-2">{{title}}</span>
    </div>
    <vs-slider
      v-model="innerModel"
      color="black"
      :step="1"
      max="100"
      :height="25"
      class="m-1"
      text-fixed="%"
    />
  </div>

</template>

<script>
export default {
  components: {
  },
  props: ['value', 'title'],
  data () {
    return {
      innerModel: 50,
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler (value) {
        this.innerModel = value
      }
    },
    'innerModel': {
      immediate: false,
      handler (value) {
        this.$emit('input', value)
      }
    },
  },
}
</script>
